import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import st from "@/styles/Ui.module.scss";
// import PlaneSVGImage from "@/svg/PlaneSVGImage.tsx";
import Button from "@/ui/Button.tsx";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useEffect, useRef} from "react";
import Images from "@/utils/images.ts";
import {useAtom} from "jotai";
import {profile} from "@/atoms/profile.ts";
import DashboardClass from "@/utils/dashboard_class.ts";


interface Props {
    nav:string
    upd():void
}

const PlaneSuccessTemplate:React.FC<Props> = ({nav, upd}) => {
    const effect_ran = useRef<boolean>(false)
    const navigate = useNavigate()
    const {t} = useTranslation()

    const [user] = useAtom(profile)

    useEffect(() => {

        if(!effect_ran.current) {
            const timeout = setTimeout(() => {
                upd()
                clearTimeout(timeout)
            }, 1000)
        }

        return () => {
            effect_ran.current = true
        }

    }, []);

    const userNoKYc = user?.kyc_general_status === "Unknown" || user?.kyc_general_status === "UserStarted"

    return (
        <DashboardGenComponent

            header_type={"hidden"}
            responsive1
            column_center={
                <div className={st.success_cr_column_center}>
                    <div className={st.congrats}>
                        <img src={Images.common.success_apply} width={320} height={320} />
                        <strong>{t("success")}</strong>
                        {userNoKYc ? (
                            <>
                                <p>{t("success_cr_line_user_no_kyc")}</p>
                                <p>{t("id_card_start_kyc")}</p>
                            </>
                        ) : (
                            <span>{t("send_cv_confirm")} {t("application_timing_approval")}</span>
                        )}
                    </div>

                    {userNoKYc ? (
                        <Button
                            onClick={() => {
                                navigate(DashboardClass.dashboard_routes.KYC)
                            }}
                        >
                            {t("start_kyc")}
                        </Button>
                    ) : (
                        <Button
                            onClick={() => {
                                navigate(nav)
                            }}
                            outlined
                        >
                            {t("application_status_track")}
                        </Button>
                    )}
                </div>
            }

        />
        

    )
}

export default PlaneSuccessTemplate